module.exports = __webpack_public_path__ + "img/settings-2_1105.aab13e3a.webp";